import React, { FunctionComponent, useMemo } from 'react';

import { GatsbyImage, GatsbyImageProps } from 'gatsby-plugin-image';

export interface FluidImageProps extends GatsbyImageProps {
  id?: string;
  hotspot?: {
    x?: number;
    y?: number;
  };
}

const FluidImage: FunctionComponent<FluidImageProps> = (props) => {
  const { id, hotspot, imgStyle = {}, ...other } = props;

  const style = useMemo(() => {
    const { x, y } = hotspot || {};
    if (typeof x === 'number' && typeof y === 'number') {
      return { objectPosition: `${x * 100}% ${y * 100}%`, ...imgStyle };
    }
    return imgStyle;
  }, [hotspot, imgStyle]);

  return <GatsbyImage loading="eager" imgStyle={style} {...other} />;
};

export default FluidImage;
